import { useLocation, Outlet } from "react-router";
import { SiteHeader } from "../site-header";
import { SiteFooter } from "../site-footer";
import { Pages } from "../../utils";

// paths that should NOT show global site header/footer
const DASHBOARD_PATHS = [
  Pages.DASHBOARD,
  Pages.PROFILE,
  Pages.MY_ACCOUNT,
  Pages.MY_BIO,
  Pages.MY_MATCHING_PROFILE,
  Pages.MY_DESIGN_FILES,
  Pages.ADD_DESIGNER_FILE,
  Pages.DESIGNER_APPLICATION,
];

export const LayoutRouter = () => {
  const location = useLocation();
  const isDashboard = DASHBOARD_PATHS.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <>
      {!isDashboard && <SiteHeader />}
      <Outlet />
      {!isDashboard && <SiteFooter />}
    </>
  );
};
